<template>
  <v-card class="mb-1">
    <v-list-item
      three-line
    >
      <v-list-item-content>
        <div
          class="overline mb-4"
          v-text="overline"
        />
        <v-list-item-title
          class="headline mb-1"
          v-text="title"
        />
        <v-list-item-subtitle
          v-if="description"
          v-text="description"
        />
        <v-checkbox
          hide-details
          dense
          :label="`Apenas minhas pendências`"
          v-model="onlyTecnico"
          @change="toggleOnlyTecnico"
        />
      </v-list-item-content>
    </v-list-item>
    <slot v-if="content" />
  </v-card>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  props: {
    overline: {
      type: String,
      default: 'overline',
      required: true
    },
    title: {
      type: String,
      default: 'título',
      required: true
    },
    description: {
      type: String,
      default: null
    },
    content: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      onlyLocal: false
    }
  },
  methods: {
    ...mapMutations(['toggleOnlyTecnico'])
  },
  computed: {
    ...mapGetters({
      local: 'onlyTecnico'
    }),
    onlyTecnico: {
      get () {
        return this.local
      },
      set (val) {
        return val
      }
    }
  }
}
</script>
